import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { CDN_TYPE_CRM, imageUrlCDN } from 'utils';

import { Label, SimpleTimer } from '@atlas/ui';

import { COMPETITION_STATUSES } from './constants';

const dateFormat = 'DD.MM.YYYY';

const TournamentCard = ({ competition }) => {
  const {
    description: { imageLink, name } = {},
    status,
    timeRange: { endTime, startTime } = {},
  } = competition;

  const imgSrc = imageUrlCDN(imageLink, CDN_TYPE_CRM);
  const dateText = `${dayjs(startTime).format(dateFormat)} - ${dayjs(endTime).format(dateFormat)}`;
  const now = Date.now();

  const PromotionInfo = useMemo(() => {
    if ([COMPETITION_STATUSES.IN_PROGRESS, COMPETITION_STATUSES.LAUNCHED].includes(status)) {
      if (startTime < now) {
        return (
          <div className="promotion-card-days">
            <Label className="promotion-card-days__text" message="left_to_finished" />
            <SimpleTimer time={endTime} />
          </div>
        );
      }

      return (
        <div className="promotion-card-days">
          <Label className="promotion-card-days__text" message="left_to_start" />
          <SimpleTimer time={startTime} />
        </div>
      );
    }
    return (
      <div className="promotion-card-days">
        <div className="promotion-card-days__text">
          <Label className="promotion-card-days__text" message={status} />
        </div>
      </div>
    );
  }, [status, startTime, endTime]);

  return (
    <div className="promotion-card">
      <div className="promotion-card__top">
        <img alt={name} className="promotion-card__img" loading="lazy" src={imgSrc} />
        <div className="promotion-card__date">{dateText}</div>
      </div>
      <div className="promotion-card__wrapper">
        <h2 className="promotion-card__text">{name}</h2>
        {PromotionInfo}
      </div>
    </div>
  );
};

TournamentCard.propTypes = {
  competition: PropTypes.shape({
    description: PropTypes.shape({
      imageLink: PropTypes.string,
      name: PropTypes.string,
    }),
    status: PropTypes.string,
    timeRange: PropTypes.shape({
      endTime: PropTypes.number,
      startTime: PropTypes.number,
    }),
  }).isRequired,
};

export default TournamentCard;
